export default __webpack_public_path__ + "static/media/code_review_bro_gray.c4ec0aeb.png";